import { render, staticRenderFns } from "./SolidColor.vue?vue&type=template&id=3dcbcd4c"
import script from "./SolidColor.vue?vue&type=script&lang=js"
export * from "./SolidColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports